// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AccountInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 13 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="13"
            height="15"
            fill="currentColor"
        >
            <path
                d="M387.378095,241.812047 C386.676294,241.126366 385.829755,240.60977 384.901905,240.300963 C386.28434,239.250948 386.846349,237.426962 386.297523,235.77152 C385.748697,234.116079 384.211974,233 382.481429,233 C380.750884,233 379.21416,234.116079 378.665334,235.77152 C378.116508,237.426962 378.678517,239.250948 380.060952,240.300963 C377.704718,241.070985 376.080381,243.248886 376,245.745862 L376,246.126755 C376,247.16132 376.831471,248 377.857143,248 L387.142857,248 C388.168529,248 389,247.16132 389,246.126755 L389,245.57727 C388.986149,244.15266 388.401065,242.794399 387.378095,241.812047 L387.378095,241.812047 Z M382.5,234.26287 C384.038508,234.26287 385.285714,235.52089 385.285714,237.072737 C385.285714,238.624584 384.038508,239.882605 382.5,239.882605 C380.961492,239.882605 379.714286,238.624584 379.714286,237.072737 C379.71769,235.522315 380.962905,234.266304 382.5,234.26287 Z M387.761905,246.126755 C387.761905,246.47161 387.484748,246.75117 387.142857,246.75117 L377.857143,246.75117 C377.515252,246.75117 377.238095,246.47161 377.238095,246.126755 L377.238095,245.745862 C377.238095,243.248202 379.553333,241.175144 382.400952,241.131435 L382.5,241.131435 C383.993114,241.101519 385.438137,241.664359 386.52381,242.698717 C387.304158,243.450782 387.75057,244.488683 387.761905,245.57727 L387.761905,246.126755 Z"
                transform="translate(-376 -233)"
            />
        </svg>
    );
};

export default React.memo(AccountInactive);
